import { createContext, useContext, useState } from "react";

const OpenContext = createContext();
const chat_ai = "chat_ai";

export function OpenProvider({ children }) {
    const [openMap, setOpenMap] = useState({});

    const setOpenById = (id, value) => {
        setOpenMap(prev => ({ ...prev, [id]: value }));
    };

    const openAIChat = (val) => {
        const opened = openMap[chat_ai];
        const state = val === undefined ? !opened : val;
        setOpenById(chat_ai, state);
    };

    return (
        <OpenContext.Provider value={{
            openMap, setOpenById,
            openAIChat, aiChat: Boolean(openMap[chat_ai])
        }}>
            {children}
        </OpenContext.Provider>
    );
}

export function useOpenContext() {
    const context = useContext(OpenContext);
    if (!context) {
        throw new Error("useOpenContext must be used within an OpenProvider");
    }
    return context;
}